const FILE_UPLOAD = 'FILE_UPLOAD';
const FILE_UPLOAD_SUCESSFULLY = 'FILE_UPLOAD_SUCESSFULLY';
export { FILE_UPLOAD, FILE_UPLOAD_SUCESSFULLY };
